import { Observable } from 'rxjs';
import { HttpResponseEntity } from '../domain/common.models';
import { PinSettingData, PinValidationData } from '../domain/pin-creation-domain.models';
import { OtpRequestData, OtpValidationData } from '../domain/pin-otp-domain.models';

/**
 * Unified Wallet PIN Transaction Repository Interface - Clean Architecture Domain Layer
 * Single abstract repository for all PIN transaction operations including OTP and PIN operations
 *
 * @businessContext
 * This repository handles the complete PIN transaction flow:
 * 1. OTP request/validation for PIN transactions
 * 2. PIN validation and setting operations
 *
 * All operations are part of the same business domain: PIN transaction security
 */
export abstract class FSWalletPinTransactionRepository {
    // ========== OTP OPERATIONS ==========

    /**
     * Request OTP for PIN transaction
     * Endpoint: POST /v1/internal/wallets/{wallet_id}/pin-transactions/request-otp
     * @param data - OTP request data
     * @returns Observable of HTTP response entity
     */
    abstract RequestWalletPinOtp(data: OtpRequestData): Observable<HttpResponseEntity>;

    /**
     * Validate OTP for PIN transaction
     * Endpoint: POST /v1/internal/wallets/{wallet_id}/pin-transactions/verify-otp
     * @param data - OTP validation data
     * @returns Observable of HTTP response entity
     */
    abstract ValidateWalletPinOtp(data: OtpValidationData): Observable<HttpResponseEntity>;

    // ========== PIN OPERATIONS ==========

    /**
     * Check PIN format and business rules
     * Endpoint: POST /v1/internal/wallets/{wallet_id}/pin-transactions/check-pin
     * @param data - PIN validation data
     * @returns Observable of HTTP response entity
     */
    abstract CheckPin(data: PinValidationData): Observable<HttpResponseEntity>;

    /**
     * Set PIN for wallet transactions
     * Endpoint: POST /v1/internal/wallets/{wallet_id}/pin-transactions/set-pin
     * @param data - PIN setting data
     * @returns Observable of HTTP response entity
     */
    abstract SetPin(data: PinSettingData): Observable<HttpResponseEntity>;
}
